import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Paper, Typography, Chip, Stack, TextField, Button } from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import PageHeader from '../../components/common/PageHeader';
import { loadPortalData, submitTicket } from '../slices/portalSlice';
import { formatRelativeTime } from '../../utils/severity';
import { tokens } from '../../theme/theme';

const STATUS_COLOR = {
  open: tokens.severity.info,
  in_progress: tokens.severity.medium,
  waiting_on_client: tokens.severity.medium,
  resolved: tokens.severity.low,
  closed: tokens.text.muted,
};

export default function PortalSupportPage() {
  const dispatch = useDispatch();
  const { tickets } = useSelector((s) => s.portal);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => { dispatch(loadPortalData()); }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!subject.trim()) return;
    dispatch(submitTicket({ subject: subject.trim(), message: message.trim() }));
    setSubject('');
    setMessage('');
  };

  return (
    <Box>
      <PageHeader title="Support" subtitle="Get help from your Melsoft CyberGuard security team" />

      <Grid container spacing={2.5}>
        <Grid item xs={12} md={5}>
          <Paper sx={{ p: 2.4 }}>
            <Typography variant="overline" sx={{ color: tokens.text.muted, fontSize: '0.65rem' }}>New Ticket</Typography>
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 1.6, mt: 1.5 }}>
              <TextField size="small" label="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} required />
              <TextField
                size="small" label="Message" value={message} onChange={(e) => setMessage(e.target.value)}
                multiline rows={5}
              />
              <Button type="submit" variant="contained" startIcon={<SendRoundedIcon fontSize="small" />}>
                Submit Ticket
              </Button>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={7}>
          <Paper sx={{ p: 2.4 }}>
            <Typography variant="overline" sx={{ color: tokens.text.muted, fontSize: '0.65rem' }}>Your Tickets</Typography>
            <Stack spacing={1.2} sx={{ mt: 1.5 }}>
              {tickets.map((t) => (
                <Box key={t.id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1.4, borderRadius: 1.5, border: `1px solid ${tokens.border}` }}>
                  <Box>
                    <Typography sx={{ fontSize: '0.82rem', color: tokens.text.primary }}>{t.subject}</Typography>
                    <Typography variant="caption" sx={{ color: tokens.text.muted, fontFamily: '"JetBrains Mono", monospace' }}>
                      {t.id} · updated {formatRelativeTime(t.updated)}
                    </Typography>
                  </Box>
                  <Chip
                    label={t.status.replace(/_/g, ' ')} size="small"
                    sx={{ color: STATUS_COLOR[t.status] || tokens.text.muted, border: `1px solid ${STATUS_COLOR[t.status] || tokens.border}`, backgroundColor: 'transparent', textTransform: 'capitalize', flexShrink: 0, ml: 1 }}
                  />
                </Box>
              ))}
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
